"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultList = void 0;
var react_1 = __importStar(require("react"));
var CenteredContainer_1 = require("@nerdwallet/currency/components/CenteredContainer");
var Type_1 = require("@nerdwallet/currency/components/Type");
var search_result_1 = __importDefault(require("../search-result/search-result"));
var search_result_list_module_css_1 = __importDefault(require("./search-result-list.module.css"));
var no_results_right_1 = __importDefault(require("./no-results-right"));
var no_results_stars_1 = __importDefault(require("./no-results-stars"));
var SearchResultList = function (_a) {
    var hits = _a.hits, query = _a.query, page = _a.page;
    var renderArticle = (0, react_1.useCallback)(function (post, index) {
        var postId = post.postId, title = post.title;
        var position = index + 1;
        return (react_1.default.createElement("li", { key: postId !== null && postId !== void 0 ? postId : title },
            react_1.default.createElement(search_result_1.default, { data: post, query: query, position: position, currentPage: page })));
    }, []);
    if (!(hits === null || hits === void 0 ? void 0 : hits.length) || hits.length === 0) {
        return (react_1.default.createElement("div", { className: search_result_list_module_css_1.default.noResultsWrapper },
            react_1.default.createElement(CenteredContainer_1.CenteredContainer, null,
                react_1.default.createElement(Type_1.Type, { size: 2, className: search_result_list_module_css_1.default.noResultsText }, "Oh my Stars! Something doesn't look right. Please try that search term again and we'll see if we can get things into focus."),
                react_1.default.createElement(Type_1.Type, { size: 2, className: search_result_list_module_css_1.default.noResultsText },
                    "Or check out our",
                    " ",
                    react_1.default.createElement("a", { href: "/", target: "_blank", className: search_result_list_module_css_1.default.noResultsHomepageLink }, "homepage"),
                    " ",
                    "to explore other topics!")),
            react_1.default.createElement(no_results_stars_1.default, { className: search_result_list_module_css_1.default.noResultsStars }),
            react_1.default.createElement(no_results_right_1.default, { className: search_result_list_module_css_1.default.noResultsRight })));
    }
    return (react_1.default.createElement(CenteredContainer_1.CenteredContainer, null,
        react_1.default.createElement("ul", { className: search_result_list_module_css_1.default.searchResultList }, hits.map(renderArticle))));
};
exports.SearchResultList = SearchResultList;
exports.default = exports.SearchResultList;
